<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="primary">
            <dropdown
                :value="value"
                :options="options"
                native
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'background-image-position',
    mixins: [baseOption],

    data() {
        return {
            customAttributeProp: 'background-position',
            displayName: 'Position',
            message: '* some options may not have any effect, depending on the image size and fill behavior',
            value: '',
        };
    },

    computed: {
        options() {
            return [
                { value: '0% 0%', text: 'Top Left' },
                { value: '50% 0%', text: 'Top Middle' },
                { value: '100% 0%', text: 'Top Right' },
                { value: '0% 50%', text: 'Center Left' },
                { value: '25% 50%', text: 'Center Left-Offset' },
                { value: '50% 50%', text: 'Center Middle' },
                { value: '75% 50%', text: 'Center Right-Offset' },
                { value: '100% 50%', text: 'Center Right' },
                { value: '0% 100%', text: 'Bottom Left' },
                { value: '50% 100%', text: 'Bottom Middle' },
                { value: '100% 100%', text: 'Bottom Right' },
            ];
        },
    },

    methods: {
        onInput(valueNew) {
            this.value = valueNew;
            this.selectedElements[0].setElementData(this.customAttributeProp, valueNew);
            this.onOptionChange(valueNew);
        },

        onSelectedElement() {
            const backgroundPosition = this.selectedElements[0].getElementData('background-position');

            this.value = backgroundPosition || '0% 0%';
        },
    },
};
</script>
